/* eslint-disable import/prefer-default-export */
import createFetch from '../createFetch';
import {
  localStorageSet,
  localStorageGet,
  localStorageClear,
} from '../service/localStorage';
import { setAuth, getAuth, authorizeRequest } from '../service/auth';

/**
 * login
 * @param {Object} json
 * @param {String} json.email
 * @param {String} json.password
 */
export async function login(json, locale) {
  const url = '/api/w1/users/sign_in.json';
  const Options = { locale };
  const options = {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(json),
  };

  try {
    return await createFetch(Options)(url, options);
  } catch (e) {
    return console.warn(e);
  }
}

/**
 * Log out
 */
export function logout() {
  localStorageClear();
}

/**
 * login with facebook
 * @param {Object} json
 * @param {String} json.access_token
 */
export async function facebookLogin(json, locale) {
  const url = '/api/w1/auth/facebook';
  const Options = { locale };
  const options = {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(json),
  };

  try {
    return await createFetch(Options)(url, options);
  } catch (e) {
    return console.warn(e);
  }
}

/**
 * login with facebook
 * @param {Object} json
 * @param {String} json.email
 * @param {String} json.password
 * @param {String} json.phone_number
 * @param {String} json.name
 * @param {Boolean} json.has_agreed_to_receive_gogovan_updates
 * @param {Boolean} json.has_agreed_to_receive_third_parties_updates
 */
export async function register(json, locale) {
  const url = '/api/w1/users.json';
  const Options = { locale };
  const options = {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(json),
  };

  try {
    return await createFetch(Options)(url, options);
  } catch (e) {
    return console.warn(e);
  }
}

/**
 * User Profile Update
 * @param  {Number}   id
 * @param  {Object}   user
 */
export async function userProfileUpdate(id, user, locale) {
  const jsonToServer = {
    user,
  };
  const auth = authorizeRequest(null);
  const url = '/api/w1/users/profile';
  const Options = { locale };
  const options = {
    method: 'PUT',
    headers: {
      Authorization: auth,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(jsonToServer),
  };

  try {
    return await createFetch(Options)(url, options);
  } catch (e) {
    return console.warn(e);
  }
}

/**
 * Update User phone number when login with facebook
 * @param  {Object}   auths
 * @param  {String}   auths.email
 * @param  {String}   auths.phone_number
 * @param  {Object}  user
 * @param  {String}  user.phone_number
 */
export async function fbuserProfileUpdate(auths, user, locale) {
  const jsonToServer = {
    user,
  };
  const auth = authorizeRequest(auths);
  const url = '/api/w1/users/profile';
  const Options = { locale };
  const options = {
    method: 'PUT',
    headers: {
      Authorization: auth,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(jsonToServer),
  };

  try {
    return await createFetch(Options)(url, options);
  } catch (e) {
    return console.warn(e);
  }
}

/**
 * Get User with Authorization
 */
export async function getUser(json, locale) {
  const url = '/api/w1/users/profile.json';
  const auth = authorizeRequest(null);
  const Options = { locale };
  const options = {
    method: 'GET',
    headers: {
      Authorization: auth,
      'Content-Type': 'application/json',
    },
  };

  try {
    return await createFetch(Options)(url, options).then(res => {
      if (res !== 401 && res !== 404) {
        res.json().then(result => {
          setAuth(
            result.user.id,
            result.user.name,
            result.user.email,
            result.user.session_token,
            result.user.phone_number,
            result.user.verified,
            getAuth().addresses,
            result.user.meta,
            result.user.gender,
            result.user.industry,
            result.user.date_of_birth,
            result.user.profile_photo,
          );
        });
      } else {
        console.warn('getUser failed');
      }
    });
  } catch (e) {
    return console.warn(e);
  }
}

/**
 * Set profile photo
 * @param {Object} profilePhoto
 * @param {int} profilePhoto.id
 * @param {Object} profilePhoto.urls
 * @param {String} profilePhoto.urls.square_small
 */
export function setProfilePhoto(profilePhoto) {
  // try backward compatible as profile_photo doesn't exist before
  if (!profilePhoto || !profilePhoto.urls) {
    return this;
  }
  const { id } = profilePhoto;
  const oldId = localStorageGet('profile_photo_id', '');

  if (id !== oldId && profilePhoto.urls) {
    const url = profilePhoto.urls.square_small;

    localStorageSet('profile_photo_id', id);
    localStorageSet('profile_photo_url', url);
    // storeProfilePhoto(url);
  }
  return this;
}

/**
 * Send SMS
 * @param {Object} profilePhoto
 * @param {function} fn // callback function for changing isSending
 */
export async function sendSMS(locale, fn) {
  const url = '/api/w1/users/send_verification_sms';
  const auth = authorizeRequest(null);
  const Options = { locale };
  const options = {
    method: 'POST',
    headers: {
      Authorization: auth,
      'Content-Type': 'application/json',
    },
  };

  try {
    const response = await createFetch(Options)(url, options).then(result => {
      if (result.status !== 401 && result.status !== 404) {
        if (fn) {
          fn(true);
        }
      } else {
        console.warn(`sendSMS:${result.status}`);
      }
    });
    return response;
  } catch (e) {
    return console.warn(e);
  }
}

/**
 * Send SMS
 * @param {Object} profilePhoto
 */
export async function verificationSMS(params, locale) {
  const url = '/api/w1/users/verify';
  const auth = authorizeRequest(null);
  const Options = { locale };
  const options = {
    method: 'POST',
    headers: {
      Authorization: auth,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      verification_code: params,
    }),
  };

  try {
    const response = await createFetch(Options)(url, options);
    return response;
  } catch (e) {
    return console.warn(e);
  }
}



// WEBPACK FOOTER //
// ./src/api/user.js